import * as yup from "yup";

const bookingReschedule = {
  date: yup.string().required("Please select a date"),
  time: yup.mixed().notOneOf(["unspecified"], "Please select a time"),
};

export const bookingRescheduleSchema = yup.object().shape(bookingReschedule);
